/*********************************************************
 * Third Components
*********************************************************/
import React, { useEffect, useState } from 'react'
import { Grid } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';

import { useIntl } from "react-intl";

/*********************************************************
 * Components
*********************************************************/
import { Button, Accordion } from 'Components';
import FromToMap from 'Components/Map/components/FromToMap'
import DirectionsMap from 'Components/Map/components/DirectionsMap'
import { TypeLayer, TypeObjectMap } from 'Components/Map/providers/enums'
import { NotificationManager } from 'Components/Notifications';
import { ToggleSwitch } from 'Components';
import Preferences from 'Core/containers/Preferences';

/*********************************************************
 * Css
*********************************************************/
import './style.scss'

/*********************************************************
 * Types
*********************************************************/
import { MapUtilitiesTypes } from '../MapUtilitiesMenu/enums';

/*********************************************************
 * Redux
*********************************************************/
import {
  addPointers,
  drawGetDirections,
  setMapRoutesOptions,
  selectCreateClickMapType,
  savePreference,
  printView,
  setToggleFullScreen
} from 'Redux/actions';

/*********************************************************
 * Vehicle directions module
*********************************************************/
const VehicleDirections = (props) => {

  const { mapRef } = props

  const { messages, locale } = useIntl();

  const fromToMapOne = 'vd_pointer_1';
  const fromToMapTwo = 'vd_pointer_2';
  const preferencesKey = 'vehicleDirections';

  const dispatch = useDispatch()
  const [markers, setMarkers] = useState([])
  const [fromTo, setFromTo] = useState()
  const [restart, setRestart] = useState(0)
  const [draw, setDraw] = useState(false)

  const [routeProps, setRouteProps] = useState({
    avoidTolls: false,
    avoidHighways: false,
    optimizeWaypoints: true
  })

  /*********************************************************
   * Get the redux properties
  *********************************************************/
  const {
    pointers,
    directions,
    generatePrint
  } = useSelector((state) => state.realtimeMapRedux);

  const {
    currentModule
  } = useSelector((state) => state.realtimeMapUtilitiesRedux);

  const { authenticatedId } = useSelector(state => state.securityRedux);

  /*********************************************************
   * Load control by default
  *********************************************************/
  useEffect(() => {
    const routeProperties = {
      optimizeWaypoints: true,
      avoidTolls: false,
      avoidHighways: false,
    }
    dispatch(drawGetDirections(false))
    setMarkers([])
    setDraw(false)
    dispatch(addPointers([]))
    setRouteProps(routeProperties)
    dispatch(setMapRoutesOptions(routeProperties))
    mapRef?.current?.showUnitsByPreferences();

    return () => {
      mapRef?.current?.showUnitsByPreferences();
    }
  }, [])

  useEffect(() => {
    if (routeProps)
      dispatch(savePreference({ entityName: "User", entityId: authenticatedId, preferenceKey: preferencesKey, preferenceValue: routeProps }));
  }, [locale])


  /*********************************************************
   * Crear the controls
  *********************************************************/
  const onClear = () => {
    //setMarkers([])
    dispatch(drawGetDirections(false))
    dispatch(addPointers([]))
    dispatch(selectCreateClickMapType(TypeObjectMap.Default))
    setRestart(restart + 1)
    setDraw(false)
    mapRef?.current?.showUnitsByPreferences();
  }

  useEffect(() => {
    if (generatePrint) {
      window.print();
      setTimeout(() => {
        dispatch(printView(false))
        dispatch(setToggleFullScreen(false));
        mapRef.current?.setZoomOut(-1);
        document.getElementById("id_sidePanel").classList.remove('hide-elementToPrint');
        document.querySelector('body').classList.remove('print-app-container');
        document.querySelector('html').classList.remove('print-app-container');
        document.getElementById('root').classList.remove('print-app-container');
        document.querySelector('#root').classList.remove('print-app-container');
        document.getElementById("id_appContainer").classList.remove('print-app-container');

        //Remove print panel
        const panelToPrint = document.getElementById('directionsPanelToPrint');
        if (panelToPrint) {
          panelToPrint.innerHTML = '';
        }

      }, 500);
    }
  }, [generatePrint])

  /*********************************************************
   * Print the map in options
  *********************************************************/
  const onPrint = () => {

    mapRef.current?.setZoomOut(1);
    dispatch(setToggleFullScreen(true));

    const panelContainer = document.getElementById('directionsPanel');
    const panelToPrint = document.getElementById('directionsPanelToPrint');
    if (panelContainer && panelToPrint) {
      panelToPrint.innerHTML = panelContainer.innerHTML;
    }

    setTimeout(() => {
      document.getElementById("id_sidePanel").classList.add('hide-elementToPrint');
      document.querySelector('body').classList.add('print-app-container');
      document.querySelector('html').classList.add('print-app-container');
      document.getElementById('root').classList.add('print-app-container');
      document.querySelector('#root').classList.add('print-app-container');
      document.getElementById("id_appContainer").classList.add('print-app-container');
    }, 500);

    setTimeout(() => {
      dispatch(printView(true));
    }, 1000);

  }

  /*********************************************************
  * Redraw route with another options
  *********************************************************/
  useEffect(() => {
    const { getDirections } = directions
    if (!getDirections && draw && currentModule == MapUtilitiesTypes.VehicleDirections) {
      dispatch(addPointers([...markers]))
      dispatch(drawGetDirections(true))
    }
  }, [directions, markers.length > 1])

  /*********************************************************
   * Draw the route into the map
  *********************************************************/
  const onGetDirections = (paramMarkers = null, drawRoute = false) => {
    const arrayMarkers = !paramMarkers ? markers : paramMarkers;
    if ((draw || drawRoute) && arrayMarkers.length > 1) {
      dispatch(drawGetDirections(false))
    }
  }

  /*********************************************************
  * When the user click on the map
  *********************************************************/
  const onClickMapPosition = (latLng, idFromTo) => {
    if (fromTo && fromTo != idFromTo) {
      return
    } else if (!fromTo) {
      return
    }
    onGetPosition(latLng, idFromTo)
  }

  /*********************************************************
  * Add the pointers into realtime maps
  *********************************************************/
  const onGetPosition = (latLng, idFromTo) => {
    const arrayMarkers = [...markers]
    const pointer = {
      id: idFromTo,
      lat: latLng.lat,
      lng: latLng.lng,
      label: 'Map Point',
      heading: 0,
      color: '000',
      eventName: 'no event',
      draggable: true
    };

    let elementPointer = arrayMarkers.find(item => item.id == idFromTo)
    if (elementPointer) {
      elementPointer.lat = latLng.lat;
      elementPointer.lng = latLng.lng;
    } else {
      arrayMarkers.push(pointer)
    }
    //Clear the markers
    setMarkers(arrayMarkers);
    dispatch(addPointers([...arrayMarkers]));
    onGetDirections(arrayMarkers);
  }

  /*********************************************************
  * Active the element selected
  *********************************************************/
  const onSelected = (idFromTo) => {
    setFromTo(idFromTo)
  }

  /*********************************************************
  * Add landmark elements
  *********************************************************/
  const onSelectLandmark = (item) => {
    const arrayMarkers = [...markers];
    let findElement = false;
    const newMarkers = arrayMarkers.map((marker) => {
      if (marker.id == item.id) {
        findElement = true
        return item
      }
      return marker
    })
    if (!findElement) {
      newMarkers.push(item)
    }

    setMarkers(newMarkers);
    dispatch(addPointers([...newMarkers]));
    onGetDirections(newMarkers);
  }

  /*********************************************************
  * get the position fron the unit into the map
  *********************************************************/
  const onSelectSelectUnit = (item, idFromTo) => {
    mapRef?.current?.showUnitsByPreferences();
    const position = mapRef.current?.getPositionMarker(item.id, TypeLayer.Units);
    if (position) {
      onGetPosition({ lat: position.lat(), lng: position.lng() }, idFromTo);
    } else {
      NotificationManager.warning(
        messages['realtimemaps_vehicledirections_nolatlng'],
        messages['realtimemaps_title'],
        3000,
        null,
        null,
        'warning',
        null
      );
    }

  }

  /*********************************************************
  * Draw the point to the position address
  *********************************************************/
  const onGetAddress = (position, idFromTo) => {
    if (position && position.length > 0) {
      onGetPosition({ lat: position[0]?.lat, lng: position[0]?.lng }, idFromTo);
    }
  }

  /*********************************************************
  * Clear point to event by user
  *********************************************************/
  const onClearAddress = (idFromTo) => {
    const arrayMarkers = markers.filter(item => item.id != idFromTo)
    dispatch(addPointers([...arrayMarkers]))
    setMarkers([...arrayMarkers])
  }

  /*********************************************************
  * Perform the action to draw route from another options
  *********************************************************/
  const setRouteProperties = (routeProperties) => {
    setRouteProps(routeProperties)
    dispatch(setMapRoutesOptions(routeProperties))
    if (draw) {
      dispatch(addPointers([]))
      dispatch(drawGetDirections(false))
    }
  }

  return (
    <div>
      <Grid container direction="row" justifyContent="space-between" alignItems="center" spacing={3}>
        <Grid item xs={12}>
          <Accordion
            defaultExpanded
            customTitle={() => { return (<b>{messages['realtimemaps_vehicledirections_from']}</b>) }}
            className="AccordionContainer-root state-mileage-accordeon"
          >
            <FromToMap
              id={fromToMapOne}
              spacing={2}
              createElements
              getCoordinates
              entities={["ADDRESS", "MAP_CLICK", "UNITS", "LANDMARK"]}
              showAll
              /* to enable multiple points to click */
              //addMorePoints 
              onSelected={onSelected}
              onGetPosition={onClickMapPosition}
              onSelectLandmark={(item) => onSelectLandmark(item)}
              onSelectSelectUnit={(item) => onSelectSelectUnit(item, fromToMapOne)}
              onGetAddress={(event) => onGetAddress(event, fromToMapOne)}
              onClear={() => { onClearAddress(fromToMapOne) }}
              restart={restart}
              messages={messages}
            //disabled={draw}
            />
          </Accordion>
          <Accordion
            defaultExpanded
            customTitle={() => { return (<b>{messages['realtimemaps_vehicledirections_to']}</b>) }}
            className="AccordionContainer-root state-mileage-accordeon"
          >
            <FromToMap
              id={fromToMapTwo}
              spacing={2}
              showAll
              entities={["ADDRESS", "MAP_CLICK", "UNITS", "LANDMARK"]}
              createElements
              getCoordinates
              onSelected={onSelected}
              onGetPosition={onClickMapPosition}
              onSelectLandmark={(item) => onSelectLandmark(item)}
              onSelectSelectUnit={(item) => onSelectSelectUnit(item, fromToMapTwo)}
              onGetAddress={(event) => onGetAddress(event, fromToMapTwo)}
              onClear={() => { onClearAddress(fromToMapTwo) }}
              restart={restart}
              messages={messages}
            //disabled={draw}
            />
          </Accordion>
          <Accordion
            customTitle={() => { return (<b>{messages['realtimemaps_vehicledirections_options']}</b>) }}
            className="AccordionContainer-root state-mileage-accordeon"
          >
            <Preferences
              preferencesKey={preferencesKey}
              onInitialPreferences={(data) => {
                setRouteProps(data);
              }}
            >
              <Grid container direction="row" justifyContent="space-between" alignItems="center" spacing={1}>
                <Grid item xs={12}>
                  <div style={{ paddingTop: 20 }}>
                    <ToggleSwitch
                      id={'avoidTolls'}
                      medium
                      mapToggle
                      optionLabels={["ON", "OFF"]}
                      checked={routeProps?.avoidTolls || false}
                      onChange={(checked) => {
                        const routeProperties = { ...routeProps, avoidTolls: checked };
                        dispatch(savePreference({ entityName: "User", entityId: authenticatedId, preferenceKey: preferencesKey, preferenceValue: routeProperties }));
                        setRouteProperties(routeProperties);
                        onGetDirections()
                      }} />
                    <label style={{ paddingLeft: 10 }}>
                      {messages['realtimemaps_vehicledirections_tolls']}
                    </label>
                  </div>
                </Grid>
                <Grid item xs={12}>
                  <div>
                    <ToggleSwitch
                      id={'avoidHighways'}
                      medium
                      mapToggle
                      optionLabels={["ON", "OFF"]}
                      checked={routeProps?.avoidHighways || false}
                      onChange={(checked) => {
                        const routeProperties = { ...routeProps, avoidHighways: checked };
                        dispatch(savePreference({ entityName: "User", entityId: authenticatedId, preferenceKey: preferencesKey, preferenceValue: routeProperties }));
                        setRouteProperties(routeProperties)
                        onGetDirections()
                      }} />
                    <label style={{ paddingLeft: 10 }}>
                      {messages['realtimemaps_vehicledirections_highways']}
                    </label>
                  </div>
                </Grid>
              </Grid>
            </Preferences>
          </Accordion>

        </Grid>
        <Grid item xs={12}>
          <Grid container
            spacing={3}
            direction="row"
            alignItems="center"
            justifyContent="space-between">
            <Grid item xs={12}>
              <div style={{ padding: 2, display: 'inline-block' }}>
                <Button
                  id={'btn-clear-bulk-edit'}
                  type="button"
                  onClick={(event) => {
                    event.preventDefault();
                    onClear()
                  }}
                  className="btn-gray"
                >
                  {messages['clear']}
                </Button>
              </div>
              <div style={{ padding: 2, display: 'inline-block' }}>
                <Button
                  id={'btn-print'}
                  type="button"
                  onClick={(event) => {
                    onPrint();
                  }}
                  className="btn-green"
                  disabled={pointers?.length < 2}
                >
                  {messages['print']}
                </Button>
              </div>
              <div style={{ padding: 2, display: 'inline-block' }}>
                <Button
                  id={'btn-save-bulk-edit'}
                  type="button"
                  onClick={(event) => {
                    event.preventDefault();
                    setDraw(true);
                    onGetDirections(null, true);
                  }}
                  className="btn-blue"
                  disabled={draw || pointers?.length < 2}
                >
                  {messages['realtimemaps_vehicledirections_getdirections']}
                </Button>
              </div>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <div style={{ maxHeight: '40vh', overflow: 'auto' }}>
            <DirectionsMap />
          </div>
        </Grid>
      </Grid>
    </div>
  )
}

export default VehicleDirections